import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Card,
    Box,
    IconButton,
} from "@mui/material";
import Utils from "../../core/Utils";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

const VendorSelectionDialog = ({
    open,
    onClose,
    vendorList = [],
    selectedVendor,
    setSelectedVendor,
    onSubmit,
}) => {
    const hasVendors = vendorList.length > 0;

    function getVendorFullAddress(vendor) {
        if (!vendor) return "";

        if (Utils.IsNullOrEmpty(vendor.vendorAddress)) {
            const parts = [
                vendor.vendorCustomAddress,
                vendor.vendorCustomCity,
                vendor.vendorCustomState,
                vendor.vendorCustomPinCode,
            ].filter(Boolean);

            return parts.join(", ");
        }

        return vendor.vendorAddress;
    }

    return (
        <BootstrapDialog
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={onClose}
            >
                <Typography
                    level="h3"
                    component="h3"
                    fontWeight="600"
                    fontSize="2rem"
                    className="h3"
                >
                    Vendor Details
                </Typography>
            </BootstrapDialogTitle>

            <DialogContent dividers className="modal-dialog-content">
                <Typography variant="h6" gutterBottom>
                    Select a Vendor
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, py: 1 }}>
                    {hasVendors ? (
                        vendorList.map((vendor, index) => (
                            <Card
                                key={index}
                                onClick={() => setSelectedVendor(vendor)}
                                sx={{
                                    padding: 2,
                                    border:
                                        selectedVendor?.vendorName === vendor.vendorName
                                            ? "4px solid #4caf50"
                                            : "1px solid #ccc",
                                    cursor: "pointer",
                                    boxShadow: 2,
                                    "&:hover": {
                                        boxShadow: 4,
                                    },
                                }}
                            >
                                <Typography
                                    variant="h3"
                                    fontSize="1.8rem"
                                    fontWeight="600">{vendor.vendorName}</Typography>
                                <Typography
                                    variant="body2"
                                    fontSize="1.4rem"
                                    color="text.secondary">
                                    📞 {vendor.vendorContact}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    fontSize="1.4rem"
                                    color="text.secondary">
                                    {getVendorFullAddress(vendor)}
                                </Typography>
                            </Card>
                        ))
                    ) : (
                        <Typography color="text.secondary">
                            No vendors available.
                        </Typography>
                    )}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    autoFocus
                    className="btn btn-primary white-text"
                    variant="contained"
                    disabled={!hasVendors}
                    onClick={onSubmit}
                >
                    Submit
                </Button>
                <Button
                    autoFocus
                    className="btn btn-secondary"
                    color="primary"
                    variant="contained"
                    style={{ backgroundColor: "gray" }}
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </DialogActions>
        </BootstrapDialog>

    );
};

export default VendorSelectionDialog;
